import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';

import type { WindowSizeReturnValue } from './types';
import { getGlobals } from '@/lib/globals/globals';

const MOBILE_THRESHOLD = 751;
export const useWindowSize = (): WindowSizeReturnValue => {
  const [windowSize, setWindowSize] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const [isMobileDevice, setIsMobileDevice] = useState(false);

  // Globals
  const {
    device: { isMobile },
  } = getGlobals();

  useEffect(() => {
    setIsMobileDevice(isMobileDevice);
  }, [isMobile]);

  useEffect(() => {
    const onResize = throttle(() => {
      setWindowSize({ height: window.innerHeight, width: window.innerWidth });
    }, 200);

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const isMobileWidth = windowSize.width < MOBILE_THRESHOLD;

  return { ...windowSize, isMobile: isMobileWidth || isMobileDevice };
};
